import React, { memo, useState, useEffect } from 'react'
import { Container, Card } from '@paypalcorp/pp-react'
import { PrivacyHubLink } from './common'
import { bool, object } from 'prop-types'
import serverData from '../../utils/server-data'
import Section from '../../components/privacyHub/section'
import PrivacyHubHeader from '../../components/privacyHub/privacy-hub-header'
import {
  constructConfigForSection,
  dataUsageConfig,
  homeConfig
} from '../../config/privacy-hub'

const { locality = {} } = serverData
const directionality = locality.directionality || 'ltr'

const PrivacyHubDataBannerSection = memo(() => (
  <>
    <Container className="privacy-hub-section-container">
      <div className="privacy-hub-wrapper">
      <PrivacyHubHeader {...homeConfig.headerSection('data')}/>
      </div>
    </Container>
  </>
))

PrivacyHubDataBannerSection.displayName = 'PrivacyHubDataBannerSection'

const PrivacyHubDataSection = memo(
  ({ image, content, orderChange = false }) => {
    let imageClass = ''
    if (!orderChange) {
      imageClass =
        directionality === 'ltr'
          ? 'right privacy-hub-data-off-white'
          : 'left privacy-hub-data-off-white'
    } else {
      imageClass =
        directionality === 'ltr'
          ? 'left privacy-hub-data-white'
          : 'right privacy-hub-data-white'
    }

    return (
      <div
        className={
          orderChange
            ? 'privacy-hub-data-toggle-off-white'
            : 'privacy-hub-data-toggle-white'
        }
      >
        <Container className="privacy-hub-data-container">
          <div className="privacy-hub-wrapper">
            <Section
              {...constructConfigForSection('Toggle_section', {
                descriptionList: content.desc?.map((desc, index) => {
                  return {
                    description: {
                      class: 'privacy-hub-text',
                      id: `${content.name}'_desc'${index}`,
                      messageId: desc,
                      size: 'sm',
                    },
                  }
                }),
                heading: {
                  size: 'lg',
                  id: `${content.name}Title`,
                  messageId: `${content.title}`,
                  class: 'privacy-hub-display-text privacy-hub-large-text',
                },
                icon_svg_link: {
                  imgSrc: `${image.src}`,
                  imgClass: `privacy-hub-data-image ${imageClass}`,
                  alt: `${image.alt}`,
                },
                order: orderChange ? 1 : 2,
                colAlign: true,
              })}
            >
              <div>
                <PrivacyHubLink
                  name={`${content.name}`}
                  message={`${content.link}`}
                  href={`${content.href}`}
                  id={`${content.id}`}
                />
              </div>
            </Section>
          </div>
        </Container>
      </div>
    )
  },
)

PrivacyHubDataSection.propTypes = {
  image: object.isRequired,
  content: object.isRequired,
  orderChange: bool,
}

PrivacyHubDataSection.displayName = 'PrivacyHubDataSection'

const PrivacyHubDataStatementSection = memo(() => (
  <Container className="privacy-hub-section-container privacy-hub-data-statement-section no-padding">
    <Card className="privacy-hub-no-bg-card no-box-shadow">
      <div className="privacy-hub-wrapper">
        <Section
          {...constructConfigForSection('Card_section', {
            description: {
              class:
                'privacy-hub-text  privacy-hub-heading-description  text-center',
              id: 'privacyStatementDesc',
              messageId: 'privacyhub.data.privacystatement.desc1',
              size: 'sm',
            },
            heading: {
              size: 'lg',
              class: 'privacy-hub-text privacy-hub-card-heading   text-center',
              id: 'privacyStatementTitle',
              messageId: 'privacyhub.data.privacystatement.title',
            },
            icon_svg_link: {
              imgSrc: `https://${serverData.cdnHostName}/paypal-ui/pictograms/blue/svg/privacy-blue.svg`,
              imgClass: 'privacy-hub-business-image privacy-hub-m-auto',
              alt: 'privacy-statement',
            },
          })}
        >
          <div className="text-center">
            <PrivacyHubLink
              name="privacyStatement"
              message="privacyhub.data.privacystatement.link"
              href="/webapps/mpp/ua/privacy-full"
              id="privacyStatementLink"
            />
          </div>
        </Section>
      </div>
    </Card>
  </Container>
))

PrivacyHubDataStatementSection.displayName = 'PrivacyHubDataStatementSection'

const PrivacyHubData = memo(() => {
  const [dataSections, setDataSection] = useState(null)

  useEffect(() => {
    let orderChange = true
    const sections = dataUsageConfig.map(({ key, enabled, content, image }) => {
      if (!enabled) {
        return null
      }
      orderChange = !orderChange
      return (
        <PrivacyHubDataSection
          key={key}
          content={content}
          image={image}
          orderChange={orderChange}
        />
      )
    })
    setDataSection(sections)
  }, [])

  return (
    <div id="privacy-hub-data">
      <PrivacyHubDataBannerSection />
      {dataSections}
      <PrivacyHubDataStatementSection />
    </div>
  )
})

PrivacyHubData.displayName = 'PrivacyHubData'

export default PrivacyHubData
